import { MapType } from './map.type'
import { Driver } from '@shared/models/driver.model'
import { Vehicle } from '@shared/models/vehicle.model'

export interface MapSettings {
  mapControls?: MapControlsSettings
  sidebar?: SidebarSettings
}

export interface MapControlsSettings {
  areClusters: boolean
  areAllGroupsSelected: boolean
  isMapMarkerTooltipShown: boolean
  isMapTrafficLayer: boolean
  isZoomToRoute: boolean
  isSearchByMap: boolean
  isCenterVehicle: boolean
  mapType: MapType
  selectedGeofencesGroupIds: (number | string)[]
}

export interface SidebarSettings {
  filters: VehicleFilterValues | GeofencesFilterValues | DriversFilterValues
  tabIndex?: DetailsTab
  sortValue: SortValue
  selectedStatus: string
}

export enum DetailsTab {
  Vehicles,
  Drivers,
  Areas,
  Assets,
}

export type SortValue = Extract<keyof Driver | keyof Vehicle, 'defaultLabel' | 'regNo' | 'fullName'>

export const SortValue: { [k: string]: SortValue } = {
  VehicleTitle: 'defaultLabel',
  VehicleRegNo: 'regNo',
  DriverName: 'fullName',
}

export interface VehicleFilterValues {
  fullSearch?: string
  groups?: number[]
  depot?: number
  name?: string
}

export interface GeofencesFilterValues {
  fullSearch?: string
  areaGroupIds?: number
  areaIds?: number[]
}

export interface DriversFilterValues {
  fullName?: string
}
